import { MenuItem } from '@airbus/components-react';
import { Cached } from '@airbus/icons/react';
import { useColumnContextAPI } from '../../../shared/context/GetAllColumnContext';
import { useLanguageContextAPI } from '../../../shared/context/LanguageContext';
import { useEffect, useState } from 'react';
import GridHeaderAction from '../../../shared/components/grid/GridHeaderAction';
import styles from './PSPActions.module.css';
import { getApiBaseUrl } from '../../../shared/utils/apiBase';

export default function PSPActions(props) {
  const { setAlertbar } = props;
  const { tableFeatureData, accessDetails: access } = useColumnContextAPI();
  const { t } = useLanguageContextAPI();
  const [isActionLoading, setIsActionLoading] = useState(null);
  const [featureData, setFeatureData] = useState(null);

  useEffect(() => {
    if (tableFeatureData) {
      setFeatureData(tableFeatureData);
    }
  }, [tableFeatureData]);

  const updateCapexHandler = () => {
    setIsActionLoading((prestate) => ({ ...prestate, update_capex_psp: true }));
    const apiBase = getApiBaseUrl();
    fetch(`${apiBase}/api/updateCapexPSP`, {
      method: 'POST',
    })
      .then((res) => res.json())
      .then((data) => {
        setIsActionLoading(null);
        // Check if the result indicates success
        const resultText = data?.npi_update_psp_data_in_sheet1_func?.result_text;
        const normalizedResultText = typeof resultText === 'string' ? resultText.trim() : '';
        const isSuccess = normalizedResultText.includes('Success');

        if (!isSuccess) {
          setAlertbar({
            children: resultText,
            severity: 'error',
          });
          return;
        }

        // Use an anchored and bounded pattern to avoid costly backtracking.
        const match = normalizedResultText.match(/^Success:\s*(\d{1,9})\s+records?\s+updated\.?$/i);
        const updatedRecords = match ? Number(match[1]) : 0;

        setAlertbar({
          children: t('psp_management.query_result', {
            count: updatedRecords,
          }),
          severity: 'success',
        });
      })
      .catch(() => {
        setIsActionLoading(null);
        setAlertbar({ children: 'Sync failed', severity: 'error' });
      });
  };

  return featureData?.update_capex_psp && access?.update_capex_psp ? (
    <GridHeaderAction>
      <MenuItem
        className={styles.menuItem}
        disabled={isActionLoading?.update_capex_psp}
        onClick={updateCapexHandler}
        icon={
          <Cached
            className={
              isActionLoading?.update_capex_psp ? `icon-spinner ${styles.icon}` : styles.icon
            }
          />
        }
      >
        {featureData?.update_capex_psp?.[`featureName`]}
      </MenuItem>
    </GridHeaderAction>
  ) : null;
}
